var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "53px",
    viewBox: "0 0 53 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-353.000000, -294.000000)",
    fill: "#F9B62F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mute",
    transform: "translate(353.000000, 294.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,52.5 C12.1405965,52.5 0.5,40.8594035 0.5,26.5 C0.5,12.1405965 12.1405965,0.5 26.5,0.5 C40.8594035,0.5 52.5,12.1405965 52.5,26.5 C52.5,40.8594035 40.8594035,52.5 26.5,52.5 Z M32.9998268,22.2697304 L38.4307909,18.4405178 C39.1897364,17.6760748 39.1897364,17.6760748 38.4307909,16.1466645 C37.6715851,14.6177785 37.6715851,14.6177785 36.1534338,16.1466645 L36.1536941,16.1464023 L14.1388087,31.4391944 C12.6203971,32.2036374 12.6203971,32.2036374 14.1388087,33.7330477 C14.8977542,35.262458 14.8977542,35.262458 15.6572202,34.4974907 L21.1918061,30.5952175 C21.8986209,33.3786015 24.4492531,35 27.0002571,35 C30.0006429,35 33,32.7570393 33,29.0186006 L32.9998268,22.2697304 Z M26.1210624,11 C23.0607935,11 20,13.184076 20,16.8243691 L20,23 L32,15.12547 C31.2194557,12.5158112 28.6699967,11.0001248 26.1209968,11.0001248 L26.1210624,11 Z M36.4529209,26 C34.9056367,26 34.9056367,26 34.9056367,27.5001837 L34.9058957,28.9998531 C34.9058957,34.2497245 31.0379503,37.9999265 25.6232512,37.9999265 C22.6527387,37.9999265 20.1463584,36.8598744 18.6612679,35.0000735 L16,36.6499155 C17.8565289,38.7198681 20.5793937,40.2499449 24.0759007,40.9997796 L24.0759007,45.4998163 C24.0759007,47 24.0759007,47 25.6231849,47 C27.1704691,47 27.1704691,47 27.1704691,45.4998163 L27.1704691,40.9997796 C34.1324525,39.5001102 38,35.0000735 38,29.0001102 L38,27.4999265 C38,26.0002571 38,26.0002571 36.4527158,26.0002571 L36.4529209,26 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.962a42ef79f332c68dc2bf9754fa6664.svg";
export { ForwardRef as ReactComponent };